import { ICredit } from 'hooks/useCredits/types';
import { FC } from 'react';
import { CreditResultItem } from './CreditResultItem';
import { ICreditResultsListProps } from './types';

export const CreditResultsList: FC<ICreditResultsListProps> = ({ results }) => {
  return (
    <>
      {results.map((item: ICredit, index: number) => (
        <CreditResultItem
          key={`${item.title}-${item.forename}-${item.middleName || ''}-${item.surname}-${
            item?.startDate || ''
          }-${index}`}
          {...item}
        />
      ))}
    </>
  );
};
